import type { ProviderUser } from "@/common/types/ProviderUser";
import { Contract } from "../enums/Contract";
import { ProviderOnboardingStep } from "../enums/ProviderOnboardingStep";

export function isAccountDetailsComplete(
  user: Pick<
    ProviderUser,
    | "credentials"
    | "acceptedContracts"
    | "onboardingStepsCompleted"
    | "firstName"
    | "lastName"
  >,
): boolean {
  // Native onboarding writes a completion marker and public name atomically.
  // The old name remains a fallback for providers who finished before that change.
  const nativeDetailsSaved =
    user.onboardingStepsCompleted.some(
      (step) => step.stepId === ProviderOnboardingStep.ACCOUNT_DETAILS,
    ) && Boolean(user.firstName?.trim() && user.lastName?.trim());
  const legacyName = user.credentials.find(
    (credential) => credential.code === "name",
  )?.value as { first_name?: string; last_name?: string } | undefined;
  const accepted = new Set(
    user.acceptedContracts.map((contract) => contract.name),
  );
  return Boolean(
    (nativeDetailsSaved || (legacyName?.first_name && legacyName?.last_name)) &&
      accepted.has(Contract.PRIVACY_POLICY) &&
      accepted.has(Contract.TERMS_OF_SERVICE),
  );
}
